export const name = 'gzTestimonial';
export default function gzTestimonial(
  // Directive angular dependencies
) {
  'ngInject';

  let directive = {
    restrict: 'EA',
    scope: {
      options: '='
    },
    template: require('./testimonial.jade'),
    link: testimonialLink,
    controller: testimonialController,
    controllerAs: 'vm',
    bindToController: true,
  };
  return directive;

  //////////////////////

  function testimonialLink(scope, element, attrs) {
  }

  /** @ngInject */
  function testimonialController(
    // Controller angular dependencies
  ) {
    // Constants

    // Variables

    // View Model
    let vm = this;
    vm.$onInit = onInit;

    return;

    function onInit() {
    }
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/carousel/testimonial/testimonial.directive.js